import { useNavigate, useParams } from "react-router-dom";
import {
  createSession,
  getRoomNumber,
  getSession,
} from "../../../actions/manageSessionsAction";
import { getModules } from "../../../actions/productsActions";
import { useEffect, useState } from "react";
import styles from "./session_form.module.css";
import {
  closeLoading,
  openLoading,
} from "../../../components/loadingModal/loading";
import alert from "../../../components/AlertModal/alertModal";
import { connect } from "react-redux";
import icon from "../../../assets/icons/navbar/sessions@4x.png";
import { getCourses } from "../../../actions/manageCoursesActions";
import { getUsers } from "../../../actions/usersActions";
import { getGroups } from "../../../actions/manageGroupsActions";
import groupIcon from "../../../assets/icons/Group_Button_Session.png";
import userIcon from "../../../assets/icons/User_Button_Session.png";
import InputText from "../../../components/InputText/index.jsx";
import DatePicker from "../../../components/DatePicker";
import verifyText from "../../../util/validations/text.js";
import "react-datepicker/dist/react-datepicker.css";
import MaterialSelect from "../../../components/MaterialSelect/index.jsx";
import ArrowGoBack from "../../../components/ArrowGoBack/ArrowGoBack.jsx";
import Button from "../../../components/Button/index.jsx";

const modes = [
  { label: "Guided", id: "Guided" },
  { label: "Assessment", id: "Assessment" },
];

const SessionForm = (props) => {
  const {
    getSession,
    getModules,
    getCourses,
    getUsers,
    getGroups,
    createSession,
    getRoomNumber,
  } = props;

  const navigate = useNavigate();
  const idMultiplayer = useParams().multiplayerId;

  const initialData = {
    session: {
      title: "",
      mode: "",
      moduleIdModule: "",
      userIdUser: "",
      dateSession: new Date(),
      groups: [],
      attendees: [],
      courseIdCourse: "",
      sessionCode: "",
      totalAttendees: [],
    },
    modules: [],
    faculties: [],
    groups: [],
    groupsCopy: [],
    attendees: [],
    attendeesCopy: [],
    courses: [],
    showGroups: true,
    showAttendees: false,
    search: "",
  };

  const [state, setState] = useState(initialData);
  const [errors, setErrors] = useState([]);

  const getInitialData = async () => {
    openLoading();
    try {
      const [modules, faculties] = await Promise.all([
        getModules({ active: true, multiplayer: true }),
        getUsers({ faculty: true }),
      ]);

      setState({ ...state, modules, faculties });

      if (idMultiplayer) {
        const session = await getSession(idMultiplayer);
        const [courses, attendees, groups] = await Promise.all([
          getCourses({ moduleIdModule: session.moduleIdModule, active: true }),
          getUsers({ moduleIdModule: session.moduleIdModule }),
          getGroups({ moduleIdModule: session.moduleIdModule }),
        ]);

        const filteredAttendees = attendees.filter(
          (attendee) =>
            !session.users.some((x) => x.idUser === attendee.idUser),
        );

        setState((prevState) => ({
          ...prevState,
          session: {
            title: session.title,
            mode: session.mode,
            moduleIdModule: session.moduleIdModule,
            userIdUser: session.userIdUser,
            dateSession: session.dateSession,
            attendees: session.users,
            courseIdCourse: session.course?.idCourse || "",
            sessionCode: session.sessionCode,
            groups: [],
            totalAttendees: session.users,
          },
          modules,
          faculties,
          groups,
          groupsCopy: groups,
          attendees: filteredAttendees,
          attendeesCopy: filteredAttendees,
          courses,
        }));
      }
    } catch (error) {
      alert("ERROR", error.message);
    } finally {
      closeLoading();
    }
  };

  useEffect(() => {
    getInitialData();
    return () => setState(initialData);
  }, []);

  const handleSelectModule = async (e) => {
    setErrors([]);
    const { value } = e.target;

    openLoading();
    try {
      const [courses, attendees, groups, roomNumber] = await Promise.all([
        getCourses({ moduleIdModule: value, active: true }),
        getUsers({ moduleIdModule: value }),
        getGroups({ moduleIdModule: value }),
        getRoomNumber(value),
      ]);

      setState((prevState) => ({
        ...prevState,
        courses,
        attendees,
        attendeesCopy: attendees,
        groups,
        groupsCopy: groups,
        session: {
          ...prevState.session,
          moduleIdModule: value,
          groups: [],
          attendees: [],
          sessionCode: roomNumber,
        },
      }));
    } catch (error) {
      alert("ERROR", error.message);
    } finally {
      closeLoading();
    }
  };

  const handleChangeSession = (e) => {
    setErrors([]);
    setState((prevState) => ({
      ...prevState,
      session: { ...prevState.session, [e.target.name]: e.target.value },
    }));
  };

  const handleSelect = (e, fieldName) => {
    const { value } = e.target;
    setState((prevState) => ({
      ...prevState,
      session: { ...prevState.session, [fieldName]: value },
    }));
    setErrors([]);
  };

  const handleCheck = (e) => {
    const { name, checked } = e.target;
    setState((prevState) => ({ ...prevState, [name]: checked }));
  };

  const handleSelectAttendee = (name, id, value) => {
    const findUsers = () => {
      let users = [...state.session.attendees];

      // Add users from groups
      state.session.groups.forEach((group) => {
        group.users.forEach((user) => {
          if (!users.some((x) => x.idUser === user.idUser)) {
            users.push(user);
          }
        });
      });

      // Add new user/group
      if (name === "groups") {
        value.users.forEach((user) => {
          if (!users.some((x) => x.idUser === user.idUser)) {
            users.push(user);
          }
        });
      } else {
        if (!users.some((x) => x.idUser === value.idUser)) {
          users.push(value);
        }
      }
      return users;
    };

    setState((prevState) => ({
      ...prevState,
      [name]: prevState[name].filter((attendee) => attendee[id] !== value[id]),
      [`${name}Copy`]: prevState[`${name}Copy`].filter(
        (attendee) => attendee[id] !== value[id],
      ),
      session: {
        ...prevState.session,
        [name]: [...prevState.session[name], value],
        totalAttendees: findUsers(),
      },
    }));
  };

  const handleRemoveAttendee = (attendee) => {
    const attendees = state.session.attendees.filter(
      (x) => x.idUser !== attendee.idUser,
    );

    const totalAttendees = () => {
      const users = [...attendees];
      state.session.groups.forEach((group) => {
        group.users.forEach((user) => {
          if (!users.some((x) => x.idUser === user.idUser)) {
            users.push(user);
          }
        });
      });
      return users;
    };

    setState((prevState) => ({
      ...prevState,
      session: {
        ...prevState.session,
        attendees,
        totalAttendees: totalAttendees(),
      },
      attendees: [...prevState.attendees, attendee],
      attendeesCopy: [...prevState.attendeesCopy, attendee],
    }));
  };

  const handleRemoveGroup = (group) => {
    const groups = state.session.groups.filter(
      (x) => x.idGroup !== group.idGroup,
    );

    const getTotalAttendees = () => {
      const users = [...state.session.attendees];
      groups.forEach((group) => {
        group.users.forEach((user) => {
          if (!users.some((x) => x.idUser === user.idUser)) {
            users.push(user);
          }
        });
      });
      return users;
    };

    setState((prevState) => ({
      ...prevState,
      session: {
        ...prevState.session,
        groups,
        totalAttendees: getTotalAttendees(),
      },
      groups: [...prevState.groups, group],
      groupsCopy: [...prevState.groupsCopy, group],
    }));
  };

  const handleSearch = (e) => {
    const search = e.target.value.toLowerCase();
    setState((prevState) => ({
      ...prevState,
      groups: prevState.groupsCopy.filter((group) =>
        group.name.toLowerCase().includes(search),
      ),
      attendees: prevState.attendeesCopy.filter(
        (attendee) =>
          attendee.firstname.toLowerCase().includes(search) ||
          attendee.lastname.toLowerCase().includes(search),
      ),
    }));
  };

  const handleSave = async () => {
    const formErrors = verifyText(state.session);
    if (formErrors.length > 0) {
      setErrors(formErrors);
      return;
    }

    openLoading();
    try {
      await createSession(state.session);
      navigate("/manage-sessions");
    } catch (error) {
      alert("ERROR", error.message);
    } finally {
      closeLoading();
    }
  };

  const renderAttendeeItem = (user) => (
    <div
      key={user.idUser}
      className={styles.attendeeItem}
      onClick={() => handleSelectAttendee("attendees", "idUser", user)}
    >
      <img src={userIcon} alt="user" className={styles.attendeeIcon} />
      <span className={styles.attendeeName}>
        {user.firstname} {user.lastname}
      </span>
    </div>
  );

  const renderGroupItem = (group) => (
    <div
      key={group.idGroup}
      className={styles.groupItem}
      onClick={() => handleSelectAttendee("groups", "idGroup", group)}
    >
      <img src={groupIcon} alt="group" className={styles.groupIcon} />
      <span className={styles.groupName}>{group.name}</span>
      <span className={styles.groupCount}>({group.users.length})</span>
    </div>
  );

  const renderSelectedAttendee = (attendee) => (
    <div key={attendee.idUser} className={styles.selectedItem}>
      <img src={userIcon} alt="user" className={styles.selectedIcon} />
      <span className={styles.selectedName}>
        {attendee.firstname} {attendee.lastname}
      </span>
      <button
        className={styles.removeButton}
        onClick={() => handleRemoveAttendee(attendee)}
        aria-label="Remove attendee"
      >
        ×
      </button>
    </div>
  );

  const renderSelectedGroup = (group) => (
    <div key={group.idGroup} className={styles.selectedItem}>
      <img src={groupIcon} alt="Group" className={styles.selectedIcon} />
      <span className={styles.selectedName}>{group.name}</span>
      <span className={styles.groupCount}>({group.users.length})</span>
      <button
        className={styles.removeButton}
        onClick={() => handleRemoveGroup(group)}
        aria-label="Remove group"
      >
        ×
      </button>
    </div>
  );

  return (
    <div className="box-container">
      <ArrowGoBack />
      <div className={styles.wrapper}>
        <div className={styles.container}>
          <header className={styles.header}>
            <button
              className="close"
              onClick={() => navigate("/manage-sessions")}
              aria-label="Close"
            />
            <img
              src={icon}
              alt="Create Group Session icon"
              className="icon_head"
            />
            <h1 className={styles.title}>
              {`${idMultiplayer ? "EDIT" : "CREATE"} GROUP SESSION`}
            </h1>
            <div className={styles.roomNumber}>
              <span className={styles.roomLabel}>ROOM NUMBER</span>
              <div className={styles.roomCode}>{state.session.sessionCode}</div>
            </div>
          </header>

          <main className={styles.content}>
            {/* Left Column */}
            <div className={styles.leftColumn}>
              <div className={styles.formSection}>
                <InputText
                  type="text"
                  placeholder="Session Title"
                  name="title"
                  value={state.session.title}
                  onChange={handleChangeSession}
                  errors={errors.filter((error) => error.label === "title")}
                />
              </div>

              <div className={styles.formSection}>
                <MaterialSelect
                  label="Course"
                  formField="courseIdCourse"
                  value={state.session.courseIdCourse}
                  onChange={(e) => handleSelect(e, "courseIdCourse")}
                  options={
                    state.courses?.map((course) => ({
                      id: course.idCourse,
                      label: course.name,
                    })) || []
                  }
                  errors={errors.some(
                    (error) => error.label === "courseIdCourse",
                  )}
                  disabled={!!idMultiplayer || !state.session.moduleIdModule}
                />
              </div>

              <div className={styles.formSection}>
                <MaterialSelect
                  label="Mode"
                  formField="mode"
                  value={state.session.mode}
                  onChange={(e) => handleSelect(e, "mode")}
                  options={modes}
                  errors={errors.some((error) => error.label === "mode")}
                />
              </div>

              <div className={styles.selectorBox}>
                <div className={styles.selectorControls}>
                  <div className={styles.controlGroup}>
                    <label className={styles.controlLabel}>
                      <input
                        type="checkbox"
                        className={styles.checkbox}
                        name="showAttendees"
                        checked={state.showAttendees}
                        onChange={handleCheck}
                      />
                      Attendees
                    </label>
                  </div>
                  <div className={styles.controlGroup}>
                    <label className={styles.controlLabel}>
                      <input
                        type="checkbox"
                        className={styles.checkbox}
                        name="showGroups"
                        checked={state.showGroups}
                        onChange={handleCheck}
                      />
                      Groups
                    </label>
                  </div>
                  <div className={styles.searchContainer}>
                    <input
                      type="text"
                      className={styles.searchInput}
                      placeholder="Search..."
                      name="search"
                      onChange={handleSearch}
                    />
                  </div>
                </div>

                <div className={styles.selectorList}>
                  {state.showGroups && state.groups.map(renderGroupItem)}
                  {state.showAttendees &&
                    state.attendees.map(renderAttendeeItem)}
                </div>
              </div>
            </div>

            {/* Right Column */}
            <div className={styles.rightColumn}>
              <div className={styles.formSection}>
                <MaterialSelect
                  label="Module"
                  formField="moduleIdModule"
                  value={state.session.moduleIdModule}
                  onChange={handleSelectModule}
                  options={
                    state.modules?.map((module) => ({
                      id: module.idModule,
                      label: module.name,
                    })) || []
                  }
                  errors={errors.some(
                    (error) => error.label === "moduleIdModule",
                  )}
                />
              </div>

              <div className={styles.formSection}>
                <MaterialSelect
                  label="Assign Host (Leave blank if you are the host)"
                  formField="userIdUser"
                  value={state.session.userIdUser}
                  onChange={(e) => handleSelect(e, "userIdUser")}
                  options={
                    state.faculties?.map((faculty) => ({
                      id: faculty.idUser,
                      label: faculty.name,
                    })) || []
                  }
                  errors={errors.some((error) => error.label === "userIdUser")}
                />
              </div>

              <div className={styles.formSection}>
                <DatePicker
                  selected={
                    state.session.dateSession
                      ? new Date(state.session.dateSession)
                      : new Date()
                  }
                  onChange={(date) => {
                    setState({
                      ...state,
                      session: { ...state.session, dateSession: date },
                    });
                  }}
                  showTimeSelect={true}
                  // timeFormat="HH:mm"
                  timeIntervals={5}
                  timeCaption="time"
                  dateFormat="MMM d, yyyy h:mm aa"
                  customInput={
                    <input
                      type="text"
                      className={`input_two ${styles.date}`}
                      placeholder="Select Date and Time (optional)"
                    />
                  }
                  placeholder="Select Date and Time"
                  errors={
                    errors &&
                    errors.filter((error) => error.label === "dateSession")
                      .length > 0
                  }
                />
                {errors.some((error) => error.label === "dateSession") && (
                  <div className={styles.errorWrapper}>
                    {errors
                      .filter((error) => error.label === "dateSession")
                      .map((error, index) => (
                        <div key={index} className={styles.error}>
                          {error.error}
                        </div>
                      ))}
                  </div>
                )}
              </div>

              <div className={styles.selectedBox}>
                <div className={styles.selectedHeader}>
                  <span>Attendees</span>
                  <span className={styles.attendeeCount}>
                    {state.session.totalAttendees.length}
                  </span>
                </div>
                <div className={styles.selectedList}>
                  {state.session.attendees?.map(renderSelectedAttendee)}
                  {state.session.groups?.map(renderSelectedGroup)}
                </div>
              </div>
            </div>
          </main>

          <footer className={styles.footer}>
            <Button
              // label={isSubmitting ? "SAVING..." : "SAVE"}
              label="SAVE"
              size="medium"
              styleButton="light"
              onClick={handleSave}
              // disabled={isSubmitting}
            />
          </footer>
        </div>
      </div>
    </div>
  );
};

export default connect(null, {
  getSession,
  getModules,
  getCourses,
  getUsers,
  getGroups,
  createSession,
  getRoomNumber,
})(SessionForm);
